export enum LEDGER_TYPES {
    GV,
    PSL,
    RAW,
    SMART,
    ECLIPSE,
    OTHER
}
